import React from "react";
import { filterSettingsIcon, filterSettingsActiveIcon } from "assets";

// Компонент кнопки фільтрів
const FilterButton = React.memo(({ onClick, isActive }) => {
  return (
    <button title="Фільтри товарів" onClick={onClick}>
      <img
        className="icon"
        src={isActive ? filterSettingsActiveIcon : filterSettingsIcon}
        alt="Фільтри"
      />
    </button>
  );
});

export default FilterButton;